"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Region = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Dynamic = require("./Dynamic");
const _excluded = ["region", "subClassName"],
  _excluded2 = ["region", "className", "subClassName", "noWrapper", "as"];
const RenderRegionComponents = _ref => {
  let {
      region,
      subClassName = ''
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, region.components && region.components.map((component, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: `region-component-${component.id}-${index}`
  }, /*#__PURE__*/_react.default.createElement(_Dynamic.Dynamic, (0, _extends2.default)({
    component: component,
    className: subClassName,
    index: index
  }, rest)))));
};
const Region = _ref2 => {
  let {
      region,
      className = '',
      subClassName = '',
      noWrapper = false,
      as = 'div'
    } = _ref2,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  if (!region || !region.components) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (!noWrapper) {
    const As = as;
    return /*#__PURE__*/_react.default.createElement(As, {
      className: className
    }, /*#__PURE__*/_react.default.createElement(RenderRegionComponents, (0, _extends2.default)({
      region: region,
      subClassName: subClassName
    }, rest)));
  }
  return /*#__PURE__*/_react.default.createElement(RenderRegionComponents, (0, _extends2.default)({
    region: region,
    subClassName: subClassName
  }, rest));
};
exports.Region = Region;